import TransportationIndex from "@/views/directory/transportation/TransportationIndex.vue";

const transportation = [
    {
        path: '/transportations',
        name: 'transportation',
        component: TransportationIndex
    }
]

export default transportation;